import {Flex, Radio, Select, Spin, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {IExamDetails, resultStore} from "../../../store/admissions/admissionStore";
import {getRequestWithParams} from "../../../api/httpRequest";
import {stepsStore} from "../../../store/admissions/stepperStore";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const style: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
};

interface IExam {
    ExamName: string,
    ExamCode: string,
    details: IExamDetails[],
}

export default function Step12() {
    const {stepsData, setStepsData} = stepsStore();
    const {result, setResult} = resultStore();
    const [showEg, setShowEg] = useState<boolean>(false);
    const [exams, setExams] = useState<IExam[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const {xl} = useBreakpoint()

    useEffect(() => {
        getRequestWithParams("/server/proxy/contracts/schedule", {ConcGroups: result.selectedConcourceGroupsCodes.join(",")})
            .then(response => {
                if (response.data.length === 0) {
                    setStepsData({
                        currentStep: stepsData.currentStep + 1,
                        completedSteps: [...stepsData.completedSteps],
                        skippedSteps: [...stepsData.skippedSteps, stepsData.currentStep],
                        nextStep: false,
                        backStep: stepsData.backStep + 1,
                        forwardStep: 0
                    })
                }
                setExams(response.data);
                setIsLoading(false);
            })
        if (["БАКСПЕЦ", "СПО11КЛАССОВ", "СПО9КЛАССОВ"].includes(result.kindsLevelFormation)) {
            setShowEg(true);
        }
    }, []);

    const setExamResults = (examCode: string, value: string) => {

        const examData = exams.find(item => item.ExamCode === examCode)?.details.find(item => item.id === value);

        const newExam = {
            ExamCode: examCode,
            ClassroomID: examData?.ClassroomID,
            Date: examData?.Date,
            Classroom: examData?.Classroom,
            id: examData?.id,
            TimeStart: examData?.TimeStart,
        }

        let newList: IExamDetails[] = result.exams

        if (result.exams.find(exam => exam.ExamCode === examCode)) {
            newList = result.exams.map(item => item.ExamCode === examCode ? newExam : item);
        } else {
            newList.push(newExam);
        }
        setResult({...result, exams: newList});
        setStepsData({...stepsData, nextStep: true});

    }

    return (
        <Flex vertical gap={42} align="center" justify="center">
            {showEg &&
                <Flex vertical gap={16} align="center" justify="center">
                    <Typography.Text strong>Укажите на основании каких испытаний планируете поступать в
                        университет:</Typography.Text>
                    <Flex vertical={true} gap={8}>
                        <Radio.Group
                            style={style}
                            onChange={(value) => {
                                setResult({
                                    ...result,
                                    EG: value.target.value === "EG",
                                    exams: value.target.value === "EG" ? [] : result.exams,
                                    Bookentryexams: value.target.value === "Bookentryexams",
                                })
                                if (value.target.value === "EG") {
                                    setStepsData({...stepsData, nextStep: true})
                                }
                            }}
                            options={[
                                {
                                    value: "EG",
                                    label: "Поступаю по баллам ЕГЭ"
                                },
                                {
                                    value: "Bookentryexams",
                                    label: "Записаться на внутренние вступительные испытания"
                                }
                            ]}
                        />
                    </Flex>
                </Flex>
            }
            {isLoading ? <Spin/> :
                exams.length !== 0 &&
                <Flex vertical gap={24} style={{width: '100%'}} justify="center" align="center">
                    <Typography.Text strong>Укажите дату внутренних вступительных испытаний, чтобы записаться на
                        сдачу:</Typography.Text>
                    <Flex vertical style={{width: '100%'}} gap={16}>
                        {exams.map((item, index) => (
                            <Flex style={{width: '100%'}} justify="center" gap={16} vertical={!xl} key={index}>
                                <Flex style={{width: xl ? '40%' : '100%'}} justify={xl ? "flex-end" : "flex-start"}
                                      align={"center"}>
                                    <Typography.Text>{`${item.ExamName}:`}</Typography.Text>
                                </Flex>
                                <Flex justify={"flex-start"}
                                      style={{width: '60%'}}>
                                    <Select
                                        style={{width: '100%'}}
                                        disabled={!result.Bookentryexams && showEg}
                                        popupMatchSelectWidth
                                        placeholder={"Выберите дату вступительных испытаний"}
                                        onSelect={(value: string) => {
                                            setExamResults(item.ExamCode, value)
                                        }}
                                        options={item.details.map((exam) => ({
                                            key: exam.id,
                                            value: exam.id,
                                            label: `${exam.Date} ${exam.TimeStart?.slice(0, 5)} ${exam.Classroom}`,
                                        }))
                                        }/>
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>
            }
        </Flex>
    )
}